module.exports = __webpack_public_path__ + "static/media/parnavee.b9e448f2.png";